module.exports = __webpack_public_path__ + "img/s3-dark.86b72157.svg";